export const wait: (miliseconds: number) => Promise<void> = (ms) =>
  new Promise((res) => setTimeout(res, ms));
